
import React, { useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import { preloadCriticalImages } from '@/utils/optimizeImages';
import { Helmet } from 'react-helmet-async';

// Import our new components
import AboutHero from '@/components/about/AboutHero';
import AboutBiography from '@/components/about/AboutBiography';
import AboutApproach from '@/components/about/AboutApproach';
import AboutCTA from '@/components/about/AboutCTA';

const About = () => {
  // Preload critical images when component mounts
  useEffect(() => {
    // Only preload the most essential images
    preloadCriticalImages([
      '/lovable-uploads/5d002198-ecfc-4ca4-9b1d-57761c26abb4.png',
    ]);
    
    // Add metadata to help browsers optimize
    if (document.head) {
      // Inform browsers this is an important page that should be preloaded
      const linkPreconnect = document.createElement('link');
      linkPreconnect.rel = 'preconnect';
      linkPreconnect.href = window.location.origin;
      document.head.appendChild(linkPreconnect);
    }
  }, []);

  return (
    <Layout>
      <div id="top"></div>
      <Helmet>
        <title>Om Oscar Gilbert | Professionel Klaverundervisning</title>
        <meta name="description" content="Mød Oscar Gilbert - konservatorieuddannet pianist med speciale i jazz, rytmisk og klassisk klaverundervisning for alle aldre og niveauer." />
        <link rel="canonical" href="https://pianoundervisning.dk/om" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Person",
              "name": "Oscar Gilbert",
              "url": "https://pianoundervisning.dk/om",
              "jobTitle": "Pianist og Klaverlærer",
              "description": "Konservatorieuddannet pianist med speciale i jazz, rytmisk og klassisk klaverundervisning",
              "alumniOf": {
                "@type": "CollegeOrUniversity",
                "name": "Rytmisk Musikkonservatorium"
              },
              "image": "https://pianoundervisning.dk/lovable-uploads/5d002198-ecfc-4ca4-9b1d-57761c26abb4.png",
              "sameAs": "https://oscargilbert.dk"
            }
          `}
        </script>
      </Helmet>
      
      <AboutHero />
      <AboutBiography />
      <AboutApproach />
      <AboutCTA />
    </Layout>
  );
};

export default React.memo(About);
